var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistribution2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.2,
    height: 51.2,
    viewBox: "0 0 51.2 51.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "distribution",
    d: "M4.5,30a4.508,4.508,0,0,0,4.242-3h6.465A10.524,10.524,0,0,0,24.1,35.892v3.5a6,6,0,1,0,3,0v-3.5a10.5,10.5,0,0,0,6.629-3.754L39.31,36.6a4.627,4.627,0,0,0-.11,1,4.5,4.5,0,1,0,9,0,4.626,4.626,0,0,0-1.294-3.208,4.377,4.377,0,0,0-6.017-.367l-5.6-4.481a10.486,10.486,0,0,0-1.277-10.322l5.547-5.473a7.51,7.51,0,1,0-2.119-2.124L31.892,17.1A10.444,10.444,0,0,0,27.1,15.108V8.742a4.5,4.5,0,1,0-3,0v6.365a10.452,10.452,0,0,0-4.785,1.986l-5.048-5.048a6.006,6.006,0,1,0-2.121,2.121l5.048,5.048A10.451,10.451,0,0,0,15.207,24H8.742A4.5,4.5,0,1,0,4.5,30Zm39.2,6a1.593,1.593,0,0,1,1.5,1.6,1.5,1.5,0,0,1-3,0A1.6,1.6,0,0,1,43.7,36ZM28.6,45.2a3,3,0,1,1-3-3A3,3,0,0,1,28.6,45.2ZM25.6,33a7.5,7.5,0,1,1,7.5-7.5A7.508,7.508,0,0,1,25.6,33ZM43.7,3a4.5,4.5,0,1,1-4.5,4.5A4.505,4.505,0,0,1,43.7,3ZM25.6,3a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,25.6,3ZM6.1,9a3,3,0,1,1,3,3A3,3,0,0,1,6.1,9ZM4.5,24A1.5,1.5,0,1,1,3,25.5,1.5,1.5,0,0,1,4.5,24Zm0,0",
    transform: "translate(0 0)",
    fill: "#a6a6a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribution2);
export default __webpack_public_path__ + "static/media/distribution (2).e33c4e21a39f4b227c4a3d4ac04a546e.svg";
export { ForwardRef as ReactComponent };